import WithRender from "../../templates/imageEditor/cornersFormat.html";
import { mapGetters } from "vuex";
import * as R from "ramda";

export default WithRender({
  computed: {
    ...mapGetters(["getCorners", "getEditor"]),
    unit: function () {
      var imageUnit = this.getEditor.dim.imageDimByFormat.unit;
      var canvasUnit = this.getEditor.dim.canvasDimByFormat.unit;
      return imageUnit / canvasUnit;
    },
    corners: function () {
      var corners = this.getCorners.corners;
      var avaibleCorners = [];
      R.forEachObjIndexed(function (corner, type) {
        if (corner.isActive) {
          var subItem = corner.subItems[corner.subItemIndex];
          var newCorner = {
            type: corner.type,
            x: corner.x,
            y: corner.y,
            subtype: subItem.type
          };
          avaibleCorners.push(newCorner);
        }
      }, corners);
      return avaibleCorners;
    }
  },
  methods: {
    getDimm: function (corner) {
      var imageUnit = this.getEditor.dim.imageDimByFormat.unit;
      var canvasUnit = this.getEditor.dim.canvasDimByFormat.unit;
      var unit = imageUnit / canvasUnit;
      if (corner.subtype == "line") {
        return {
          width: "0px",
          height: "0px",
          "border-left": corner.x + "px solid transparent",
          "border-right": corner.x * this.unit + "px solid transparent",
          "border-top": corner.y * this.unit + "px solid transparent",
          "border-bottom": corner.y * this.unit + "px solid transparent"
        };
      }
      if (corner.subtype == "circle" || corner.subtype == "circle2") {
        var boxShadow =
          corner.subtype == "circle2"
            ? "#808080 " +
              -1 * 2 * corner.x +
              "px " +
              -1 * 2 * corner.x +
              "px " +
              " 0px " +
              1 * 2 * corner.x +
              "px"
            : "none";
        if (corner.type == "right_bottom")
          boxShadow =
            corner.subtype == "circle2"
              ? "#808080 " +
                1 * 2 * corner.x +
                "px " +
                1 * 2 * corner.x +
                "px " +
                " 0px " +
                1 * 2 * corner.x +
                "px"
              : "none";
        if (corner.type == "left_bottom")
          boxShadow =
            corner.subtype == "circle2"
              ? "#808080 " +
                -1 * 2 * corner.x +
                "px " +
                1 * 2 * corner.x +
                "px " +
                " 0px " +
                1 * 2 * corner.x +
                "px"
              : "none";
        if (corner.type == "right_top")
          boxShadow =
            corner.subtype == "circle2"
              ? "#808080 " +
                1 * 2 * corner.x +
                "px " +
                -1 * 2 * corner.x +
                "px " +
                " 0px " +
                1 * 2 * corner.x +
                "px"
              : "none";
        return {
          width: 2 * corner.x * unit + "px",
          height: 2 * corner.x * unit + "px",
          "box-shadow": boxShadow
        };
      }
    }
  }
});
